import {useEffect} from 'react';
import {matchPath, useLocation} from 'react-router-dom';
import {isFinance, isPl} from 'shared/lib/isFinance';

const BRAND_ROCKET_WORK = 'RocketWork';
const BRAND_FINANCE = 'rocket finance';
const BRAND_PL = 'RocketP';

const PAGE_TITLES: Array<{path: string; title: string}> = [
	{path: '/auth/login', title: 'Вход'},
	{path: '/download-app', title: 'Скачать приложение'},
	{path: '/registration', title: 'Регистрация'},
	{path: '/orders/:orderId', title: 'Заказ'},
	{path: '/offers/:offerId', title: 'Предложение'},
	{path: '/orders', title: 'Мои заказы'},
	{path: '/offers', title: 'Предложения'},
	{path: '/notifications', title: 'Уведомления'},
	{path: '/profile/data', title: 'Данные'},
	{path: '/profile/documents', title: 'Документы'},
	{path: '/profile/statuses', title: 'Статусы'},
	{path: '/profile/auto-reply', title: 'Автоотклик'},
	{path: '/profile/terms', title: 'Условия и правила'},
	{path: '/profile/receipt', title: 'Сформировать чек'},
	{path: '/profile/certificate', title: 'Сформировать справку'},
	{path: '/profile/payment-ways/account', title: 'Счёт'},
	{path: '/profile/payment-ways/card', title: 'Карта'},
	{path: '/profile/payment-ways/sbp', title: 'СБП'},
	{path: '/profile', title: 'Профиль'},
	{path: '/', title: 'Предложения'},
];

export function getLkBrandTitle(): string {
	if (isPl()) return BRAND_PL;
	if (isFinance()) return BRAND_FINANCE;

	return BRAND_ROCKET_WORK;
}

export function getLkPageName(pathname: string): string | null {
	for (const route of PAGE_TITLES) {
		if (matchPath({path: route.path, end: true}, pathname)) {
			return route.title;
		}
	}

	return null;
}

export function formatLkDocumentTitle(pathname: string): string {
	const brand = getLkBrandTitle();
	const pageName = getLkPageName(pathname);

	if (!pageName) {
		return `${brand} - Страница не найдена`;
	}

	return `${brand} - ${pageName}`;
}

export function DocumentTitle(): null {
	const {pathname} = useLocation();

	useEffect(() => {
		document.title = formatLkDocumentTitle(pathname);
	}, [pathname]);

	return null;
}
